import { useEffect, useMemo, useRef, useState } from 'react';
import './style.css';
import authService from '../../../service/auth';
import { Center, Dropdown, FileUpload, FormField, FormGroup, Input, Popup, Textarea } from '../../../components/Form';
import { useNavigate, useParams } from 'react-router-dom';
import { FaDownload } from "react-icons/fa6";
import { IoIosEye } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { toastError, toastSuccess } from '../../../BTUI/BtToast';
import { updateTaxfile, updateTaxfileStatus } from '../../../store/userSlice';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import { showDatetime } from '../../../utils/formatter';
import { IconCopy, IconDelete, IconRefresh, IconVerify, IconView } from '../../../BTUI/Icons';
import { Button } from '../../../components/Button';
import { RiDeleteBin6Line } from 'react-icons/ri';
import AskForPayment from '../payments/AskForPayment';
import { List, ListBody, ListWrapper } from '../../../BTUI/List';


const TaxFileDetail = () => {
    const [details, setDetails] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [toggleUpdateWindow, setToggleUpdateWindow] = useState(false);
    const [showAskPayment, setShowAskPayment] = useState(false);
    const [showAddComment, setShowAddComment] = useState(false);
    const [taxfileStatus, setTaxfileStatus] = useState([])
    const [docType, setDocType] = useState([])
    const [verificationConfirm,setVerificationConfirm] = useState(null)
    const [copySuccess, setCopySuccess] = useState({});
    const [deleteComment,setDeleteComment] = useState(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const param = useParams()

    const getDetails = () => {
        setIsLoading(true)
        authService.taxfileDetail(param?.id)
            .then(res => {
                setDetails(res?.data?.taxfile)
            })
            .catch(err => {
                console.log('Error in taxfiledetail', err)
            })
            .finally(()=>{
                setIsLoading(false)
            })
    }
    

    useEffect(() => {
        getDetails()
        authService.getTaxfileStatus()
            .then((res) => {
                setTaxfileStatus(res?.data?.response?.taxfileStatusList)
            })
            .catch((err) => {
                // console.log(err)
            });

        authService.getDocumentTypes()
            .then((res)=>{
                setDocType(res?.data?.response?.documentTypesList)
                console.log(res)
            })
            .catch((err)=>{
                
                console.log(err)
            });
    }, [toggleUpdateWindow])


    const handleStatusChange = (name, value) => {
         // showLoader()
        dispatch(updateTaxfileStatus({ taxfile_id: param?.id, file_status: value }))
            .then((res) => {
                getDetails();
                toastSuccess(res?.data?.message);
                // hideLoader()
            })
            .catch((err) => {
                toastError(err?.data?.message)
                //hideLoader()
            });
    };

    const handleToggleUpdate = () =>{
        setToggleUpdateWindow((prev)=>!prev)
    }

    const handleAskForPaymentClose = () => {
        getDetails()
        setShowAskPayment(false)
    }

    const handleVerification = (id) => {
        authService.verifyPaymentOrder(id,{})
        .then((res)=>{
            getDetails()
            toastSuccess(res?.data?.message);
            setVerificationConfirm(null)
        })
        .catch((err)=>{
            toastError(err?.data?.message)
        })
    }

    const handleRefresh = (id) => {
        authService.refreshPaymentOrderStatus(id,{})
        .then((res)=>{
            getDetails()
            toastSuccess(res?.data?.message);
        })
        .catch((err)=>{
            toastError(err?.data?.message)
        })
    }

    const handleCommentDelete = (id) => {
        authService.taxfileDeleteComment(deleteComment)
        .then((res)=>{
            getDetails()
            setDeleteComment(null)
            toastSuccess(res?.data?.message);
        })
        .catch((err)=>{
            toastError(err?.data?.message)
        })
    }

    const handleCopyUrl = (url,id) => {
        navigator.clipboard.writeText(url)
          .then(() => {
            setCopySuccess((prev) => ({ ...prev, [id]: "Copied!" }));
            setTimeout(() => {
              setCopySuccess((prev) => ({ ...prev, [id]: null }));
            }, 800);
          })
          .catch(() => {
            setCopySuccess((prev) => ({ ...prev, [id]: "Copy Failed!" }));
          });
      };

    

    return <PanelLayout>

        
<Popup 
                        maxWidth="30em"
                        trigger={verificationConfirm}
                        setTrigger={()=>setVerificationConfirm(null)}
                    >
                        Veriy amount {verificationConfirm?.amount} ?

                        <br/>
                        <br/>
                        <div className="" style={{display: 'flex', gap: '1em'}}>
                            <Button varient="action-btn primary" title="Verify" onClick={()=>handleVerification(verificationConfirm?.id)}/>
                            <Button varient="action-btn sec" title="Cancel" onClick={()=>setVerificationConfirm(false)}/>
                        </div>
                        
                    </Popup>
        <>
                <h1 style={{ textAlign: 'center' }}>Tax Return file details </h1>
                <br />
                {
                    details ?
                    <div className="userDetails-section">
                    <div className="userDetails-inner-container">
                    <FormGroup>
                            <FormField>
                                <Dropdown
                                    label="Update Taxfile Status"
                                    name="file_status"
                                    selected={details?.file_status}
                                    options={{ list: taxfileStatus, name: "name", value: "code" }}
                                    handleChange={handleStatusChange}
                                />
                            </FormField>
                        </FormGroup>
                        <div style={{ width: '100%',display: 'flex', justifyContent: 'flex-end', gap: '1em'}}>
                            <Button title="Go To Chat" varient="action-btn green" onClick={()=>navigate(`/executive/message/${details?.user_id}`)}/>
                            <Button title="Upload Documents" varient="action-btn green" onClick={handleToggleUpdate}/>
                            <Button title="Ask For Payments" varient="action-btn green" onClick={()=>setShowAskPayment(true)}/>
                        </div>
                        

                        <div className='userDetails-head-content'>
                            
                            <div className="userDetails-txt-content">
                                <DetailsComponent
                                    heading="First Name"
                                    value={details?.profile?.firstname}
                                />
                                <DetailsComponent
                                    heading="Last Name"
                                    value={details?.profile?.lastname}
                                />
                                <DetailsComponent
                                    heading="Date of Birth"
                                    value={details?.profile?.date_of_birth}
                                />
                                <DetailsComponent
                                    heading="Marital Status"
                                    value={details?.profile?.marital_status_detail?.name}
                                />
                                <DetailsComponent
                                    heading="Mobile Number"
                                    value={details?.profile?.mobile_number}
                                />
                                <DetailsComponent
                                    heading="Created on"
                                    value={showDatetime(details?.added_on)}
                                />
                                <DetailsComponent
                                    heading="File Status"
                                    value={details?.file_status_name}
                                />
                                
                                <DetailsComponent
                                    heading="Is Existing Client"
                                    value={details?.profile?.existing_client == 'YES' ? 'YES' : 'NO'}
                                />
                                {/* <DetailsComponent
                                    heading="Unread Messages"
                                    value={details?.client_message_count}
                                /> */}
                            </div>
                            <div className="userDetails-txt-content">
                                <DetailsComponent
                                    heading="Street Number"
                                    value={details?.profile?.street_number}
                                />
                                <DetailsComponent
                                    heading="Street Name"
                                    value={details?.profile?.street_name}
                                />
                                <DetailsComponent
                                    heading="City"
                                    value={details?.profile?.city}
                                />
                                <DetailsComponent
                                    heading="Province"
                                    value={details?.profile?.province_detail?.name}
                                />
                                <DetailsComponent
                                    heading="Postal Code"
                                    value={details?.profile?.postal_code}
                                />
                                <DetailsComponent
                                    heading="Tax Year"
                                    value={details?.tax_year}
                                />
                                <DetailsComponent
                                    heading="Direct Deposit CRA"
                                    value={details?.direct_deposit_cra}
                                />
                                <DetailsComponent
                                    heading="Moved to Canada"
                                    value={details?.moved_to_canada}
                                />
                                <DetailsComponent
                                    heading="Date of Entry"
                                    value={details?.date_of_entry}
                                />
                            </div>
                        </div>

                        {details?.showSingleDocument && <div className="userDetails-img-content">
                            <FormField>
                                <FileComponent
                                    name="Document (setup or change your direct deposit with CRA) : "
                                    download={details?.document_direct_deposit_cra}
                                    downloadName={details?.document_direct_deposit_cra}
                                    view={details?.document_direct_deposit_cra}
                                />
                            </FormField>
                        </div>}
                        


                        <div className="userDetails-img-content">
                            <h4 style={{marginBottom: '0.5em', fontWeight: '550'}}>Client Uploaded Documents</h4>
                            <hr/>
                            {details?.documents?.map((itm, index) => {
                                    return itm?.user_type === "CLIENT" && <FormGroup key={index}>
                                        <FormField>
                                            <FileComponent
                                                name={itm?.type?.name || 'Document'}
                                                download={itm?.full_path}
                                                downloadName={itm?.documents?.[index]?.filename}
                                                view={itm?.full_path}
                                            />
                                        </FormField>

                                    </FormGroup>
                                    // : <p style={{color: 'grey', marginTop: '1em'}}>No Record Found</p>
                                })
                            }
                        </div>

                        <div className="userDetails-img-content">
                            <h4 style={{marginBottom: '0.5em', fontWeight: '550'}}>Executive Uploaded Documents</h4>
                            <hr/>
                            {details?.documents?.map((itm, index) => {
                                    return itm?.user_type === "EXECUTIVE" && <FormGroup key={index}>
                                        <FormField>
                                            <FileComponent
                                                name={itm?.type?.name || 'Document'}
                                                download={itm?.full_path}
                                                downloadName={itm?.documents?.[index]?.filename}
                                                view={itm?.full_path}
                                            />
                                        </FormField>

                                    </FormGroup>
                                    // : <p style={{color: 'grey', marginTop: '1em'}}>No Record Found</p>
                                })
                            }

                        </div>

                        
                        <div className="userDetails-img-content">
                            <h4 style={{marginBottom: '0.5em', fontWeight: '550'}}>Payment Request Orders</h4>
                            <hr/>
                            {/* <ListWrapper> */}
                                <List 
                                thead={[
                                    {title:'title', width:'30%'},
                                    {title:'amount', width:'20%'},
                                    {title:'payment status', width:'20%'},
                                    {title:'Verify', width:'10%'},
                                    {title:'Url', width:'10%'},
                                    {title:'Created on', width:'10%'},
                                    {title:'', width:'5%'},
                                ]}>
                                    <ListBody>
                                        {
                                            details?.payment_orders?.map((order)=>{
                                                return <>
                                                    <tr>
                                                        <td>{order?.id} {order?.title}</td>
                                                        <td>{order?.amount}</td>
                                                        <td>{order?.payment_status}</td>
                                                        <td>{order?.payment_status == 'Paid' ? <Button maxWidth={'100%'}
                                                            varient="icon"
                                                            title={<IconVerify color='green' />}
                                                            onClick={() => setVerificationConfirm({id:order?.id, amount:order?.amount, status:'Verified'})}
                                                            /> : null}
                                                        </td>
                                                        <td>
                                                            {order.payment_url && (copySuccess[order.id] ? <small style={{ marginLeft: '3px', color: 'green' }}>{copySuccess[order.id]}</small> : <IconCopy size='1.5em' onClick={() => handleCopyUrl(order?.payment_url, order.id)}/>)}
                                                        </td>
                                                        <td>{order?.payment_status != 'Paid' ? <Button maxWidth={'100%'}
                                                            varient="icon"
                                                            title={<IconRefresh color='blue' />}
                                                            onClick={() => handleRefresh(order?.id)}
                                                            /> : null}
                                                        </td>                                                        
                                                    </tr>
                                                </>
                                            })
                                        }

                                    </ListBody>
                                </List>
                        </div>


                        <div className="userDetails-img-content">
                            <div style={{display:'flex',gap:'5px',alignItems:'center'}}>
                            <h4 style={{marginBottom: '0.5em', fontWeight: '550'}}>Internal Comments</h4>
                            <Button title="Add Comment" varient="action-btn green" onClick={()=>setShowAddComment(true)}/>
                                </div>
                            <hr/>
                            {/* <ListWrapper> */}
                                <List 
                                thead={[
                                    {title:'Comment', width:'78%'},
                                    {title:'Added on', width:'20%'},
                                    {title:'', width:'2%'},
                                ]}>
                                    <ListBody>
                                        {
                                            details?.comments?.map((row)=>{
                                                return <>
                                                    <tr>
                                                        <td>{row?.comment}</td>
                                                        <td>{showDatetime(row?.added_on)}</td>
                                                        
                                                        <td><IconDelete onClick={()=>setDeleteComment(row?.id)} />
                                                        </td>                                                        
                                                    </tr>
                                                </>
                                            })
                                        }

                                    </ListBody>
                                </List>
                        </div>

                        <div style={{ width: '100%',display: 'flex', justifyContent: 'flex-end', gap: '1em'}}>

                        </div>
                    </div>
                </div>
                :
                    isLoading 
                    ? 
                    <div style={{textAlign:'center'}}>
                        <span>Loading. Please wait</span>
                    </div>
                    :
                    <div style={{color:'red',textAlign:'center'}}>
                        <span>No records found</span>
                    </div>

                }

                <Popup
                    trigger={toggleUpdateWindow}
                    setTrigger={handleToggleUpdate}
                >
                    <UpdateTaxFile 
                    setToggleUpdateWindow={setToggleUpdateWindow} 
                    />
                </Popup>

                <Popup
                    trigger={showAskPayment}
                    setTrigger={()=>setShowAskPayment(!showAskPayment)}
                >
                    <AskForPayment 
                    taxfile_id = {param?.id} 
                    setToggleUpdateWindow={handleAskForPaymentClose} 
                    />
                </Popup>

                
                <Popup
                    trigger={showAddComment}
                    setTrigger={()=>setShowAddComment(!showAddComment)}
                >
                    <AddComment 
                    taxfile_id = {param?.id} 
                    setShowAddComment={setShowAddComment}
                    handleSuccess={getDetails} 
                    />
                </Popup>

                <Popup 
                    maxWidth="30em"
                    trigger={deleteComment}
                    setTrigger={()=>setDeleteComment(null)}
                >
                    Want to delete comment ?
                    <br/>

            <br/>
            <div className="" style={{display: 'flex', gap: '1em'}}>
                <Button varient="action-btn primary" title="Verify" onClick={handleCommentDelete}/>
                <Button varient="action-btn sec" title="Cancel" onClick={()=>setDeleteComment(null)}/>
            </div>
                                
        </Popup>
            </>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </PanelLayout>

}

export default TaxFileDetail;


const DetailsComponent = (props) => {

    return <div className="details-component-section">
        <label>
            {props?.heading}
        </label>
        <p>{props?.value}</p>
    </div>
}

const FileComponent = (props) => {

    return <div className="file-component-section">
        <label>
            {props?.name}
        </label>
        <div className="file-component-btn-div">
            <a href={props?.download} download={props?.downloadName} target="_blank" rel="noreferrer"><FaDownload /></a>
            {/* <a href="/" onClick={() => { window.open(props?.view, "_blank") }}><IoIosEye /></a> */}
            <a href={props?.view} target='_blank'><IoIosEye /></a>
        </div>
    </div>
}

const UpdateTaxFile = (props) => {
    const [oldDocs, setOldDocs] = useState([])
    const [newDocs, setNewDoc] = useState([{documents: [{}]}])
    const [errors, setErrors] = useState({})
    const [loadingButton, setLoadingButton] = useState(false)
    const [payload, setPayload] = useState({});
    const [docType, setDocType] = useState([])
    const dispatch = useDispatch()
    const param = useParams()

    useEffect(()=>{
        authService.taxfileDetail(param?.id)
            .then(res => {
                setOldDocs(res?.data?.taxfile?.documents.filter(doc => doc?.user_type === "EXECUTIVE"))
            })
            .catch(err => {
                console.log('Error in taxfiledetail', err)
            })
        authService.getDocumentTypes({type:'executive'})
            .then((res)=>{
                setDocType(res?.data?.response?.documentTypesList)
                console.log(res)
            })
            .catch((err)=>{
                
                console.log(err)
            });
    },[])


    const handleChange = (name, value) => {
        setPayload({
            ...payload,
            [name]: value,
        });
    };

    const handleAddForm = () => {
        let oldArr = [...newDocs];
        let newArr = [...oldArr];
        newArr.push({});
    
        setNewDoc(newArr);
    };

    const handleChangeArray = (name, value, thisIndex) => {
        let oldArr = [...newDocs];
        let curRow = { ...oldArr[thisIndex] };
        curRow[name] = value;
        oldArr[thisIndex] = curRow;

        setNewDoc(oldArr);
    };

    const handleDeleteArray = (delIndex) => {
        setNewDoc(newDocs?.filter((itm, ind) => {return ind !== delIndex;})
        );
    };

    const handleDelete = (index) =>{
        setOldDocs(oldDocs?.filter((itm) => {return itm?.id !== index}))
    }



    const handleSubmit = () => {
        setLoadingButton(true)
        const documents = [...newDocs]

        oldDocs.forEach(doc=>{
            documents.push({id: doc?.id})
        })

        dispatch(updateTaxfile({
            id: param?.id, 
            notify_client: payload?.notifyToClient,
            documents: documents,
        }))
            .then((res) => {
            
                toastSuccess(res?.data?.message);
                setLoadingButton(false)
                props?.setToggleUpdateWindow(false)
            })
            .catch((err) => {
                if (err?.data?.field_errors) {
                    setErrors(err?.data?.field_errors);
                } 
                toastError(err?.data?.message)
                console.log("Error", err)
                setLoadingButton(false);
            });
      };


    
    return<>
        {oldDocs?.map((itm,index) => {
            return itm?.user_type === "EXECUTIVE" && <OldDocsComponent key={index}
                name={itm?.type?.name}
                handleDelete={()=>handleDelete(itm?.id)}
            />
        })}

        {/* <FormSectionName name="Attach Documents" /> */}
        {newDocs?.map((itm, index) => {
        return (
            <FormGroup key={index}>
            <FormField>
                <Dropdown
                    label="Document Type"
                    name="typeid"
                    selected={itm?.typeid}
                    options={{ list: docType, name: "name", value: "id" }}
                    handleChange={(name, value) =>
                        handleChangeArray(name, value, index)
                    }
                />
            </FormField>
            <FormField>
                <div className="array-div">
                <FileUpload
                    label="."
                    name="taxfile"
                    fileName={itm?.taxfile?.name}
                    handleFileChange={(name, value) =>
                        handleChangeArray(name, value, index)
                    }
                />

                {<Button maxWidth={'100%'}
                    varient="icon"
                    title={<IconDelete />}
                    onClick={() => handleDeleteArray(index)}
                />}
                
                </div>
            </FormField>
            </FormGroup>
        );
        })}
        <div
        className=""
        style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        }}
        >
        <button style={{ padding: "8px" }} onClick={handleAddForm}>
            + Add More Documents
        </button>
        </div>
        <Center>
            <div className='notify-checkbox'>
                <input 
                    type='checkbox'
                    name='notifyToClient'
                    checked={payload?.notifyToClient}
                    onChange={(e)=>handleChange('notifyToClient', e?.target?.checked)}
                />

                <p>Notify to client</p>
            </div>
        </Center>
        <br />
        <div style={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}>
        <Button
            name="addTaxFile"
            title="Update"
            onClick={handleSubmit}
        />
        </div>
        <br />
    </>
}

const OldDocsComponent = (props) => {

    return (
        <div className="file-component-section">
            <div>{props?.name}</div>
            <div className="file-component-btn-div">
                <Button maxWidth={'100%'}
                    varient="icon"
                    title={<IconDelete />}
                    onClick={props?.handleDelete}
                />
            </div>
        </div>
    );
};



const AddComment = (props) => {
    const [loadingButton, setLoadingButton] = useState(false)
    const [errors,setErrors] = useState({})
    const [payload, setPayload] = useState({});
    const handleChange = (name, value) => {
        setPayload({
            ...payload,
            [name]: value,
        });
    };

    const handleSubmit = () => {
        setLoadingButton(true)

        authService.taxfileAddComment(props?.taxfile_id,payload)
        .then((res) => {
            props?.handleSuccess()
            setPayload({})
            
            toastSuccess(res?.data?.message);
            setLoadingButton(false)
            props?.setShowAddComment(false)
        })
        .catch((err) => {
            if (err?.data?.field_errors) {
                setErrors(err?.data?.field_errors);
            } 
            toastError(err?.data?.message)
            setLoadingButton(false);
        });

      };


    
    return<>
                <div
        className=""
        style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        }}
        >
        </div>

        <Center>
            <Textarea
                label="Comment"
                name="comment"
                value={payload?.comment}
                error={errors?.comment}
                handleChange={handleChange}
            />

        </Center>
        <br/>

        <br />
        <div style={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}>
        <Button
            disabled={payload?.comment?.length < 1}
            loading={loadingButton}
            name="addComment"
            title="Add Comment"
            onClick={handleSubmit}
        />
        </div>

        
        <br />
    </>
}
